import { Component, inject } from '@angular/core';
import type { ToastConfig } from 'src/app/_services/toast.service';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

// Ported from customer-website's app-toast-msg (icon-badge card design)
@Component({
    selector: 'app-toast-msg',
    templateUrl: './toast-msg.component.html',
    styleUrls: ['./toast-msg.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class ToastMsgComponent {
    // Inject the instance of the currently open snackbar to control closing it
    snackBarRef = inject(MatSnackBarRef);

    // Inject the custom payload passed from the service
    toastData: ToastConfig = inject(MAT_SNACK_BAR_DATA);

    toastClose(): void {
        this.snackBarRef.dismiss();
    }
}
